var React = require('react');

function Campaign (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"campaign","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M5.0586982,5.33837225 C5.02070348,5.23269189 5,5.11876372 5,5 C5,4.44771525 5.44771525,4 6,4 C6.44983944,4 6.83030532,4.29702352 6.9559753,4.70564823 L12.1486833,20.2837722 L10.2513167,20.9162278 L5.0586982,5.33837225 Z M8,5 C8.97324219,4.33333333 10.1399089,4 11.5,4 C13.5744053,4 14.6828125,6 17.5,6 C19.284158,6 20.4508247,5.66666667 21,5 C21.0057943,6.66829427 20.3377604,8.0016276 18.9958984,9 C16.9831055,10.4975586 14.9240234,9.60507813 13,11 C11.7173177,11.9299479 11.050651,12.9299479 11,14 L8,5 Z","id":"Shape","fill":"currentColor","fillRule":"nonzero"})));
}

Campaign.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = Campaign;

Campaign.default = Campaign;
